import { CheckCircle2, ShieldCheck, Clock3, BadgeCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { WhatsAppButton } from "@/components/WhatsAppButton";

const points = [
  "Pembiayaan RM3,000 – RM100,000",
  "Tempoh bayaran sehingga 7 tahun",
  "Semakan kelayakan 100% PERCUMA",
  "Tiada bayaran pendahuluan",
];

export const Hero = () => (
  <section
    data-testid="hero-section"
    className="relative noise-overlay overflow-hidden bg-navy"
  >
    <img
      src="https://images.pexels.com/photos/7735691/pexels-photo-7735691.jpeg?auto=compress&cs=tinysrgb&w=1600"
      alt=""
      loading="eager"
      fetchpriority="high"
      className="absolute inset-0 h-full w-full object-cover opacity-20"
    />
    <div className="absolute inset-0 bg-gradient-to-b from-navy/80 via-navy/85 to-navy" />

    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-20 sm:pt-24 sm:pb-28">
      <div className="max-w-2xl">
        <Reveal>
          <span
            data-testid="hero-badge"
            className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-gold/10 px-4 py-1.5 text-xs sm:text-sm font-semibold uppercase tracking-widest text-gold-light"
          >
            <ShieldCheck className="w-4 h-4" />
            Konsultan Pembiayaan Malaysia
          </span>
        </Reveal>

        <Reveal delay={0.08}>
          <h1
            data-testid="hero-heading"
            className="mt-6 font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white leading-[1.08]"
          >
            Perlukan{" "}
            <span className="gold-text-gradient">Bantuan Kewangan?</span>
          </h1>
        </Reveal>

        <Reveal delay={0.16}>
          <p
            data-testid="hero-subtitle"
            className="mt-5 text-base sm:text-lg text-slate-300 leading-relaxed max-w-xl"
          >
            EY 58 Group membantu anda membuat semakan kelayakan pembiayaan
            peribadi &amp; perniagaan — percuma, pantas dan tanpa komitmen.
          </p>
        </Reveal>

        <Reveal delay={0.24}>
          <ul
            data-testid="hero-selling-points"
            className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3.5"
          >
            {points.map((point) => (
              <li key={point} className="flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 mt-0.5 shrink-0 text-gold" />
                <span className="text-sm sm:text-base font-medium text-slate-100">
                  {point}
                </span>
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={0.32}>
          <div className="mt-10 flex flex-col sm:flex-row sm:items-center gap-4">
            <WhatsAppButton
              location="hero"
              testId="hero-whatsapp-button"
              size="lg"
              pulse
            >
              Hubungi Kami di WhatsApp
            </WhatsAppButton>
            <div className="flex items-center gap-4 text-xs sm:text-sm text-slate-400">
              <span className="inline-flex items-center gap-1.5">
                <Clock3 className="w-4 h-4 text-gold" /> Respons pantas
              </span>
              <span className="inline-flex items-center gap-1.5">
                <BadgeCheck className="w-4 h-4 text-gold" /> Tanpa komitmen
              </span>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
